// extracted by mini-css-extract-plugin
export default {"app":"Main_app__RxXvy","appSafari":"Main_appSafari__NdI8e","top":"Main_top__YCKzc","body":"Main_body__g2tVX","bottom":"Main_bottom__jq8HC"};